export const pUpdatePaykey = Object.seal({
    email: '',
    paykey: '',
    verifyCode: ''
})

export const pRecharge = Object.seal({
    rechargeKey: '',
    verifyCode: '',
    email: ''
})
